import isObject from 'lodash-es/isObject';

import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import { Generator } from '@holmescorp/topic-generator';
import { TopicAttrs, TopicDetails, TopicElement } from 'lcc-state/interfaces';

import css from '../../css/expanded.m.css';

const isEleWithKids = (v: any): v is TopicDetails => {
	return isObject(v) && 'children' in v;
};

const isSimpleTopic = (v: any): v is TopicElement => {
	return isObject(v) && 'p' in v;
};

export interface ShortDescriptionProperties {
	topicdata: string | TopicDetails;
	additionalClasses?: string[];
}

const factory = create({ theme }).properties<ShortDescriptionProperties>();

export const ShortDescription = factory(({ properties, middleware: { theme } }) => {
	const themeCss = theme.classes(css);
	const { topicdata, additionalClasses = [] } = properties();

	const render_description = (topicdata: any): DNode => {
		if (isEleWithKids(topicdata)) {
			return w(Generator, {
				skipTitle: true,
				topic: { attributes: {} as TopicAttrs, children: topicdata.children as any }
			});
		} else if (isSimpleTopic(topicdata)) {
			return w(Generator, {
				skipTitle: true,
				topic: { attributes: {} as TopicAttrs, children: [topicdata] }
			});
		} else if (typeof topicdata === 'string') {
			return topicdata;
		}
		return null;
	};

	return v('div', { classes: [themeCss.shortDesc, ...additionalClasses], xqa: 'shortdesc' }, [
		render_description(topicdata)
	]);
});

export default ShortDescription;
